export interface CatalogCustomer {
	CustomerId: number | null;
	CustomerName: string;
	IsActive: boolean;
	CreatedBy: string | null;
	CreatedDate: Date | null;
	ModifiedBy: string | null;
	ModifiedDate: Date | null;
}

export const CATALOG_CUSTOMER_INITIAL_VALUES: CatalogCustomer = {
	CustomerId: null,
	CustomerName: "",
	IsActive: true,
	CreatedBy: null,
	CreatedDate: null,
	ModifiedBy: null,
	ModifiedDate: null,
};
